import config from './config.vue';
import cart from './cart.vue';
import initModalContent from './feature-detail.vue';

export default {
  components: {
    config,
    cart,
    initModalContent
  },
};
